export default function Terms() {
  return (
    <section className="container py-10">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
        Terms of Use
      </h1>
      <p className="text-gray-600 dark:text-gray-300">
        These are the terms of use. Include responsibilities, limitations of
        liability, and other legal details.
      </p>
    </section>
  );
}
